import { isEqual } from "lodash";

export const shallowLeftDiff = <T extends object>(
  oldValues: T,
  newValues: T
) => {
  // NOTE: this is only a "shallow" comparison, because the API should
  //   ... not support "deep patching" or "nested serializers"
  return Object.entries(newValues).reduce((diff, [key, value]) => {
    if (!isEqual(oldValues[key as keyof typeof newValues], value)) {
      return {
        ...diff,
        [key]: value,
      };
    }
    return diff;
  }, {});
};
